<div class="elz-sidebar elz-padding__top--small elz-padding__bottom--small elz-flex__parent elz-flex-column">
  @if (!$isLoading()) {
    <div class="elz-flex__child--fixed">
      <div
        [class.flex-justify--center]="!$isSidebarExpanded()"
        class="display--flex flex-gap--small flex-align--center margin--small margin--left margin--top margin--right margin--bottom"
      >
        <img
          class="elz-logo__icon"
          src="assets/img/elementz-logo.svg"
          width="32"
          height="32"
          alt="Elementz"
          data-testid="elementz-logo"
        />
        @if ($isSidebarExpanded()) {
          <img
            src="assets/img/elementz-logo-title.svg"
            width="162"
            height="20"
            alt="Elementz"
            data-testid="elementz-title"
          />
        }
      </div>

      <div class="sidebar-header" [class.expanded]="$isSidebarExpanded()">
        @if ($isSidebarExpanded() && siteType) {
          <mat-chip-set class="elz-padding__left--small">
            <mat-chip>{{ siteType }}</mat-chip>
          </mat-chip-set>
        }
        <button
          mat-mini-fab
          color="primary"
          class="elz-margin--small"
          (click)="toggleMenu()"
          data-testid="button-sidebar-expand"
        >
          <mat-icon>
            {{ $isSidebarExpanded() ? leftPanelCloseIcon : leftPanelOpenIcon }}
          </mat-icon>
        </button>
      </div>
      @if ($isSidebarExpanded()) {
        <div class="elz-margin--small">
          <mat-form-field
            class="full-width"
            data-testid="element-form-field-selector"
            subscriptSizing="dynamic"
          >
            <mat-label>Integrity Elementz</mat-label>
            <mat-select
              [placeholder]="'Select Element'"
              [value]="$selectedElement()?.elementId"
              (valueChange)="changeElement($event)"
              data-testid="element-selector"
            >
              @for (element of $availableElements(); track element.elementId) {
                <mat-option [value]="element.elementId" [attr.data-testid]="element.name + '-option'">
                  {{ element.name }}
                </mat-option>
              }
              <mat-option [value]="-1" data-testid="element-option-none">Select Element</mat-option>
            </mat-select>
          </mat-form-field>
        </div>
      }
    </div>
    <div class="elz-flex__child--grow elz-scrollable">
      <app-menu />
      @if ($includeHelp()) {
        <div class="elz-margin__top--small elz-margin__bottom--large">
          <mat-divider />
        </div>
        <app-sidebar-help />
      }
    </div>
  } @else {
    <div class="elz-flex-centered">
      <mat-progress-spinner [mode]="'indeterminate'" data-testid="sidebar-spinner" />
    </div>
  }
</div>
